import { render, staticRenderFns } from "./ComponentsSidebar.vue?vue&type=template&id=31c31dd2&scoped=true&"
import script from "./ComponentsSidebar.vue?vue&type=script&lang=ts&"
export * from "./ComponentsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentsSidebar.vue?vue&type=style&index=0&id=31c31dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c31dd2",
  null
  
)

export default component.exports